import ReactGA from 'react-ga';

export const setMetaTags = (title: string, excerpt: string) => {
  document.title = title;

  ReactGA.pageview(window.location.pathname + window.location.search);

  const desc = document.querySelector('meta[name="description"]');

  if (!desc) return;

  desc.setAttribute('content', excerpt);
};

export const conststripHtml = (html: string) => {
  // Create a new div element
  const temporalDivElement = document.createElement('div');

  // Set the HTML content with the providen
  temporalDivElement.innerHTML = html;

  // Retrieve the text property of the element (cross-browser support)
  return temporalDivElement.textContent || temporalDivElement.innerText || '';
};

export const hrefTitle = (title: string) => {
  return conststripHtml(
    title.replaceAll('-', '').replace(/  +/g, ' ').replaceAll(' ', '+')
  );
};
